import React from 'react';
import Bootstrap, { Scripts } from '../bootstrap';
import MicroComponent from '../common/MicroComponent';
import AuroraData from '../../pactum-server/stubs/auroraFactory';

const ProductPage: React.FC = (args) => {
  const auroraData = AuroraData();

  return (
    <Bootstrap scripts={[Scripts.Flights, Scripts.Maps, Scripts.Checkout, Scripts.Search]}>
      <MicroComponent micro={{ sdkName: SERVICE_SDK_NAME, componentName: 'ProductPage' }} {...auroraData} />
    </Bootstrap>
  );
};

export default ProductPage;
